import React from 'react'
import { useField } from 'formik'
import { ImageType } from '@interfaces/ImageType'
import { UploadFileProps, UploadFileAcceptProps } from './interface'

export function withUploadFile(Component: React.FC<UploadFileProps>) {
  function WithUploadFile({ name, ...props }: UploadFileAcceptProps) {
    const [{ value }, { touched, error }, { setValue }] =
      useField<ImageType>(name)

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
      const { files } = event.target

      if (files?.length) {
        setValue({
          url: URL.createObjectURL(files[0]),
          name: files[0].name,
          blob: files[0],
        })
      }
    }

    const componentProps = {
      ...props,
      name,
      image: value,
      touched,
      error,
      onChange: handleChange,
    }

    return <Component {...componentProps} />
  }

  WithUploadFile.defaultProps = {
    textButton: 'อัปโหลด',
    acceptTypes: 'image/jpeg,image/png',
  }

  return WithUploadFile
}
